import SpeedActions from "./SpeedActions";
import PreviewShareButton from "./PreviewShareButton";

const PreviewActions = ({
    preview,
    onSpeedClick,

}) => {

    return <div>
        <SpeedActions />

        {/* <div style={{ textAlign: 'left', padding: '16px 16px' }}>
            <PreviewShareButton
                buttonStyle={{ verticalAlign: 'middle' }}
                iconStyle={{ fontSize: '20px', verticalAlign: 'middle' }}
                trackId={preview.fullTrackId}
                messageIndex={preview.messageIndex}
                title={preview.title}
                showLabel={true}
            />
        </div> */}

    </div>;
};

export default PreviewActions;